// City landing pages — single source of truth for SEO city pages.
// `name` must match a key in backend geo.py SWISS_CITIES for near_city search.

const slugify = (s) =>
  s.toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const CITIES = [
  { name: 'Zürich', canton: 'Zürich' },
  { name: 'Bern', canton: 'Bern' },
  { name: 'Basel', canton: 'Basel Stadt' },
  { name: 'Luzern', canton: 'Luzern' },
  { name: 'Genf', canton: 'Genf' },
  { name: 'Lausanne', canton: 'Waadt' },
  { name: 'St. Gallen', canton: 'St. Gallen' },
  { name: 'Winterthur', canton: 'Zürich (Region)' },
  { name: 'Zug', canton: 'Zug' },
  { name: 'Chur', canton: 'Graubünden' },
  { name: 'Lugano', canton: 'Tessin' },
  { name: 'Schaffhausen', canton: 'Schaffhausen' },
  { name: 'Biel', canton: 'Bern' },
  { name: 'Thun', canton: 'Bern' },
  { name: 'Aarau', canton: 'Aargau' },
  { name: 'Baden', canton: 'Aargau' },
  { name: 'Sion', canton: 'Wallis' },
  { name: 'Fribourg', canton: 'Fribourg' },
  { name: 'Neuenburg', canton: 'Neuenburg' },
  { name: 'Solothurn', canton: 'Solothurn' },
  { name: 'Olten', canton: 'Solothurn' },
  { name: 'Kriens', canton: 'Luzern' },
  { name: 'Emmen', canton: 'Luzern' },
  { name: 'Frauenfeld', canton: 'Thurgau' },
].map((c) => ({ ...c, slug: slugify(c.name) }));

export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
